import React, { FormHTMLAttributes } from "react";

type Props = FormHTMLAttributes<HTMLFormElement>;

export function ClientForm({ onSubmit, ...props }: Props) {
  const formSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    onSubmit && onSubmit(event);
  };

  return <form onSubmit={formSubmit} {...props}></form>;
}
